const colors = {
  primary: '#4c70ba',
  danger: '#cc5454',
  success: '#36b777',
  warning: '#f2b330'
}

export default colors



// WEBPACK FOOTER //
// ./src/styles/colors.js